export default {
  admin: "admin",
  manager: "manager",
};
